import React from "react";

import { Text, textPropTypes } from "../Text";

/** The Sub component renders subscript text. */
export const Sub = (props) => <Text element="sub" isSubScript {...props} />;

Sub.displayName = "Sub";

Sub.propTypes = textPropTypes;
